<template>
  <article class="mt-4">
    <AssistantInformation :value="model" :disabled="disabled" />
    <SchoolInformation
      :items="model.schools"
      :collections="collections"
      :submitted="disabled"
      :validate.sync="invalidSchool"
    />
    <ItemsSelectionSection
      :items="model.assistanceAreas"
      :selection-list="collections.necessities"
      :disabled="disabled"
    />
  </article>
</template>

<script>
import alert from '@/mixin/alert.mixin';
import AssistantInformation from './components/AssistantInformation';
import SchoolInformation from './components/SchoolInformation';
import ItemsSelectionSection from './components/ItemsSelectionSection';

export default {
  name: 'Tab1GeneralInformation',
  mixins: [alert],
  components: {
    AssistantInformation,
    SchoolInformation,
    ItemsSelectionSection,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    collections: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    invalidSchool: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model() {
      return this.value;
    },
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
::v-deep .dot {
  background-color: white !important;
  .title-icon {
    color: #ff7058;
  }
}
</style>
